import { render } from "./Pagination.vue?vue&type=template&id=18d42e0e&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=18d42e0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18d42e0e"

export default script